// extracted by mini-css-extract-plugin
export default {"projectsSection":"Projects_projectsSection__e3u+j","titleWrapper":"Projects_titleWrapper__1pscH"};